import { IStyleableProps } from "lib/interfaces/IStyleableProps";
import { connect } from "react-redux";
import UserDucks from "stores/ducks/User.duck";

export interface IOnlyLoggedInProps extends IStyleableProps {
  isLoggedIn?: boolean;
}
const OnlyLoggedIn = (props: IOnlyLoggedInProps) => {
  return props.isLoggedIn ? props.children : null;
};

const mapStateToProps = state => {
  return {
    isLoggedIn: UserDucks.isAuthenticated(state)
  };
};

export default connect(mapStateToProps)(OnlyLoggedIn);



// WEBPACK FOOTER //
// ./src/components/guards/OnlyLoggedIn.tsx